(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dolce-lab-page"] && !Shopify.designMode) return;
  try {
    
(()=>{function init(scope){scope.querySelectorAll('[data-dp-lab]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='1';const buttons=[...root.querySelectorAll('[data-lab-product]')],image=root.querySelector('.dp-lab-main-image'),zoom=root.querySelector('[data-lab-zoom]');if(!buttons.length||!image)return;function choose(button){buttons.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));image.removeAttribute('srcset');image.src=button.dataset.image;image.alt=button.dataset.title;image.style.transform='scale(1)';zoom.value=100;root.querySelector('[data-lab-title]').textContent=button.dataset.title;root.querySelector('[data-lab-price]').textContent=button.dataset.price;root.querySelector('[data-lab-continue]').href=button.dataset.url;if(!matchMedia('(prefers-reduced-motion: reduce)').matches)image.animate([{opacity:.35,transform:'scale(.97)'},{opacity:1,transform:'scale(1)'}],{duration:350,easing:'ease-out'});}buttons.forEach(b=>b.addEventListener('click',()=>choose(b)));root.querySelector('[data-lab-random]').addEventListener('click',()=>{const other=buttons.filter(b=>b.getAttribute('aria-pressed')!=='true');choose(other[Math.floor(Math.random()*other.length)]||buttons[0]);});zoom.addEventListener('input',()=>image.style.transform='scale('+Number(zoom.value)/100+')');});}init(document);document.addEventListener('shopify:section:load',e=>init(e.target));})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dolce-ritual-page"] && !Shopify.designMode) return;
  try {
    
(() => {function init(scope){scope.querySelectorAll('[data-dp-ritual]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='1';root.querySelectorAll('[data-ritual-tab]').forEach(button=>button.addEventListener('click',()=>{root.querySelectorAll('[data-ritual-tab]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));root.querySelectorAll('[data-ritual-panel]').forEach(panel=>panel.hidden=panel.dataset.ritualPanel!==button.dataset.ritualTab);}));});}init(document);document.addEventListener('shopify:section:load',e=>init(e.target));})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dolce-stores-page"] && !Shopify.designMode) return;
  try {
    
(()=>{function init(scope){scope.querySelectorAll('[data-dp-stores]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='1';root.querySelectorAll('[data-city]').forEach(button=>button.addEventListener('click',()=>{root.querySelectorAll('[data-city]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));root.querySelectorAll('[data-store-city]').forEach(card=>card.hidden=button.dataset.city!=='all'&&card.dataset.storeCity!==button.dataset.city);}));});}init(document);document.addEventListener('shopify:section:load',e=>init(e.target));})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dolce-stores"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dolce-stores')) {
    customElements.define('dolce-stores', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.dolce-stores__track');
        this.cards = Array.from(this.querySelectorAll('.dolce-stores__card'));
        this.nav = this.querySelector('.dolce-stores__navigation');
        this.buttons = Array.from(this.querySelectorAll('[data-direction]'));
        this.counter = this.querySelector('[data-store-current]');
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.update = () => {
          const max = this.track.scrollWidth - this.track.clientWidth;
          const position = this.track.scrollLeft;
          this.nav.hidden = max < 2;
          this.buttons[0].disabled = position <= 2;
          this.buttons[1].disabled = position >= max - 2;
          const step = this.cards[0]?.getBoundingClientRect().width + 1 || 1;
          const index = position >= max - 2 ? this.cards.length : Math.round(position / step) + 1;
          this.counter.textContent = String(Math.min(index, this.cards.length));
        };
        this.buttons.forEach(button => button.addEventListener('click', () => {
          const step = this.cards[0]?.getBoundingClientRect().width + 1 || 1;
          this.track.scrollBy({ left: Number(button.dataset.direction) * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }, { signal }));
        this.track.addEventListener('scroll', this.update, { passive: true, signal });
        document.addEventListener('shopify:block:select', event => {
          const card = event.target.closest('.dolce-stores__card');
          if (card && this.contains(card)) card.scrollIntoView({ block: 'nearest', inline: 'start', behavior: 'instant' });
        }, { signal });
        this.observer = new ResizeObserver(this.update);
        this.observer.observe(this.track);
        this.update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dolce-wholesale-page"] && !Shopify.designMode) return;
  try {
    
(()=>{function init(scope){scope.querySelectorAll('[data-dp-wholesale]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='1';root.querySelectorAll('[data-wholesale-choice]').forEach(button=>button.addEventListener('click',()=>{root.querySelectorAll('[data-wholesale-choice]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));root.querySelectorAll('[data-wholesale-panel]').forEach(p=>p.hidden=p.dataset.wholesalePanel!==button.dataset.wholesaleChoice);}));});}init(document);document.addEventListener('shopify:section:load',e=>init(e.target));})();

  } catch(e) { console.error(e); }
})();
})();
